import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header, Footer } from '../components/HomePage';
import Accessibility from '../components/HomePage/Footer/Accessibility';

function AccessibilityPage() {
  return (
    <>
      <Helmet>
        <title>Accessibility Statement | Circledin - Accessible Mobile Plan Platform</title>
        <meta 
          name="description" 
          content="Read Circledin's Accessibility Statement. Learn about our commitment to providing an accessible mobile plan sharing platform for users with disabilities." 
        />
        <meta name="keywords" content="accessibility statement, WCAG compliance, disability access, screen reader support, keyboard navigation, circledin, mobile plans, universal design, assistive technology" />
        <meta name="robots" content="index, follow" />
        
        {/* Open Graph meta tags */}
        <meta property="og:title" content="Accessibility Statement | Circledin - Accessible Mobile Plan Platform" />
        <meta property="og:description" content="Learn about Circledin's commitment to accessibility and how we ensure our platform is usable by people with disabilities." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://circledin.com/accessibility" />
        
        {/* Twitter Card meta tags */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Accessibility Statement | Circledin - Accessible Mobile Plan Platform" />
        <meta name="twitter:description" content="Learn about Circledin's commitment to accessibility and how we ensure our platform is usable by people with disabilities." />
        
        {/* Additional Accessibility-Specific Meta Tags */}
        <meta name="accessibility-statement" content="https://circledin.com/accessibility" />
        <meta name="wcag-compliance" content="WCAG 2.1 AA compliant" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://circledin.com/accessibility" />
        
        {/* Additional SEO Meta Tags */}
        <meta name="author" content="Circledin, Inc." />
        <meta name="publisher" content="Circledin, Inc." />
        <meta name="copyright" content="© 2025 Circledin, Inc." />
        <meta name="language" content="EN" />
        <meta name="revisit-after" content="30 days" />
        
        {/* Schema.org Structured Data for Accessibility Statement */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Accessibility Statement",
            "description": "Circledin's Accessibility Statement explaining our commitment to providing an accessible platform for all users.",
            "url": "https://circledin.com/accessibility",
            "inLanguage": "en-US",
            "isPartOf": {
              "@type": "WebSite",
              "name": "Circledin",
              "url": "https://circledin.com"
            },
            "author": {
              "@type": "Organization",
              "name": "Circledin, Inc.",
              "url": "https://circledin.com"
            },
            "datePublished": "2025-01-01",
            "dateModified": "2025-01-01",
            "mainEntity": {
              "@type": "DigitalDocument",
              "name": "Circledin Accessibility Statement",
              "description": "Comprehensive accessibility statement detailing our commitment to WCAG 2.1 AA compliance and inclusive design.",
              "version": "1.0",
              "datePublished": "2025-01-01",
              "author": {
                "@type": "Organization",
                "name": "Circledin, Inc."
              },
              "accessibilityFeature": [
                "alternativeText",
                "captions",
                "highContrast",
                "keyboardNavigation",
                "screenReaderSupport",
                "structuralNavigation"
              ],
              "accessibilityControl": [
                "fullKeyboardControl",
                "fullMouseControl",
                "fullTouchControl",
                "fullVoiceControl"
              ],
              "accessibilityAPI": [
                "ARIA"
              ],
              "accessibilityEvent": [
                "onFocus",
                "onBlur",
                "onSelect"
              ]
            }
          })}
        </script>
      </Helmet>
      
      <Header />
      <Accessibility />
      <Footer />
    </>
  );
}

export default AccessibilityPage;